export enum AuthAPIErrorCodeEnum {
    NotGranted = 1,
}
